<template>
  <div 
    :class="[
      'group bg-teal-700 text-white rounded-lg shadow-lg min-w-[220px] border-2 transition-all relative overflow-visible',
      selected ? 'border-cyan-400 shadow-cyan-400/50' : data.__validationError ? 'border-red-500' : 'border-teal-800'
    ]"
  >
    <!-- Header -->
    <div class="bg-teal-800 px-3 py-2 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-sm">school</span>
        <span class="font-semibold text-sm">{{ $t('flowEditor.nodes.botRespondWithKbNode.title') }}</span>
      </div>
      <ExitNodeBadge :active="data.__isExitNode" />
      <ValidationMarker :error="data.__validationError" />
    </div>
    
    <!-- Body -->
    <div class="px-3 py-3 flex flex-col gap-2 text-sm">
      <!-- Source Variable -->
      <div v-if="data.sourceVariable" class="text-teal-200 text-xs font-medium flex items-center gap-1">
        <span class="material-icons" style="font-size: 12px;">input</span>
        <span>{{ $t('flowEditor.nodes.botRespondWithKbNode.fromLabel') }}: <span class="font-mono">{{ data.sourceVariable }}</span></span>
      </div>
      <div v-else class="text-teal-300 italic text-xs">
        {{ $t('flowEditor.nodes.botRespondWithKbNode.emptyPlaceholder') }}
      </div>

      <!-- Configuration summary -->
      <div v-if="data.sourceVariable" class="text-teal-200 text-xs flex flex-col gap-1 pt-2 border-t border-teal-600">
        <div v-if="data.maxDocuments" class="flex items-center gap-1">
          <span class="material-icons" style="font-size: 12px;">description</span>
          <span>{{ $t('flowEditor.nodes.botRespondWithKbNode.maxDocs', { n: data.maxDocuments }) }}</span>
        </div>
        <div v-if="data.minConfidenceScore !== undefined" class="flex items-center gap-1">
          <span class="material-icons" style="font-size: 12px;">assessment</span>
          <span>{{ $t('flowEditor.nodes.botRespondWithKbNode.confidence', { n: (data.minConfidenceScore * 100).toFixed(0) }) }}</span>
        </div>
      </div>

      <!-- Output Variable -->
      <div v-if="data.outputVariable" class="text-teal-200 text-xs flex items-center gap-1 mt-2 pt-2 border-t border-teal-600">
        <span class="material-icons" style="font-size: 12px;">save</span>
        <span>→ <span class="font-mono">{{ data.outputVariable }}</span></span>
      </div>
    </div>

    <!-- Target Handle (input, left) -->
    <Handle
      type="target"
      :position="Position.Left"
      class="w-3 h-3 !bg-teal-400 !border-2 !border-white"
    />

    <!-- Source Handle (output, right) -->
    <Handle
      type="source"
      :position="Position.Right"
      class="w-3 h-3 !bg-teal-400 !border-2 !border-white"
    />
    <!-- Add node button -->
    <AddNodeButton v-if="!hasOutgoingEdge" @add="emit('add-node', nodeId)" />
  </div>
</template>

<script setup>
import { Handle, Position } from '@vue-flow/core';
import ExitNodeBadge from './ExitNodeBadge.vue';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';

const emit = defineEmits(['add-node']);

defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
  nodeId: { type: String, required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});
</script>
